import { Lock } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useApps } from "@/lib/api";

/**
 * "Geen toegang": for someone who typed or followed the address of an app
 * they may not open, under the app's own title. It names the dashboard's
 * admins, who grant apps through the teams, and leads back home. The app
 * itself is in no menu for them.
 */
export function AppAccessDenied() {
  const { t } = useTranslation();
  const { data, isPending } = useApps();
  const contacts = data?.contacts ?? [];
  return (
    <Card>
      <CardContent className="space-y-5 pt-6">
        <div className="flex items-start gap-3">
          <Lock aria-hidden="true" className="text-primary mt-1 size-5 shrink-0" />
          <h2 className="font-heading text-primary min-w-0 text-lg font-bold">
            {t("apps.denied.title")}
          </h2>
        </div>
        {contacts.length > 0 ? (
          <section aria-labelledby="app-denied-contacts" className="pl-8">
            <h3 id="app-denied-contacts" className="text-foreground text-sm font-medium">
              {t("apps.denied.contactsTitle")}
            </h3>
            <ul className="mt-1 space-y-1 text-sm">
              {contacts.map((contact) => (
                <li key={contact.email} className="break-words">
                  {contact.name && <span className="text-foreground">{contact.name} </span>}
                  <a
                    href={`mailto:${contact.email}`}
                    className="text-primary focus-visible:ring-ring rounded-sm break-all underline focus-visible:ring-2 focus-visible:outline-none"
                  >
                    {contact.email}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        ) : (
          !isPending && <p className="text-muted pl-8 text-sm">{t("apps.denied.noContacts")}</p>
        )}
        <div className="pl-8">
          <Button asChild variant="outline">
            <Link to="/home">{t("notFound.home")}</Link>
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
